<div class="o1 m-b-1 b-b uppercase"
     (click)="open()"
     [toggleClass]="'!b-col-t !cursor-pointer !col-11 b-col-1 col-1'"
     [toggleClassBy]="tabsLink">
    <ng-content></ng-content>
</div>
